var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dealings-check-accounts-view2-multi-currency" },
    [
      _c(
        "div",
        {
          staticClass: "section operations",
          staticStyle: { "margin-bottom": "2px" }
        },
        [
          _c(
            "el-form",
            { staticStyle: { "margin-bottom": "-8px" }, attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_FiscalPeriod") } },
                [
                  _c(
                    "el-select",
                    {
                      ref: "fromFPRef",
                      staticStyle: { width: "120px" },
                      attrs: { no: "1" },
                      model: {
                        value: _vm.form.fromFP,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fromFP", $$v)
                        },
                        expression: "form.fromFP"
                      }
                    },
                    _vm._l(_vm.fiscalPeriods, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.fiscalPeriodLabelFun(item),
                          value: item.uuid
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_To") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { no: "2" },
                      model: {
                        value: _vm.form.toFP,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "toFP", $$v)
                        },
                        expression: "form.toFP"
                      }
                    },
                    _vm._l(_vm.fiscalPeriods, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.fiscalPeriodLabelFun(item),
                          value: item.uuid
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessDate") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "120px" },
                    attrs: { format: "yyyy-MM-dd", no: "3" },
                    model: {
                      value: _vm.form.businessDateStart,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "businessDateStart", $$v)
                      },
                      expression: "form.businessDateStart"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_To") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "120px" },
                    attrs: { format: "yyyy-MM-dd", no: "4" },
                    model: {
                      value: _vm.form.businessDateEnd,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "businessDateEnd", $$v)
                      },
                      expression: "form.businessDateEnd"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_BusinessDocNo") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "140px" },
                    attrs: { no: "5" },
                    model: {
                      value: _vm.form.projectNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "projectNumber", $$v)
                      },
                      expression: "form.projectNumber"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Abstract") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { no: "6" },
                    model: {
                      value: _vm.form.summaryText,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "summaryText", $$v)
                      },
                      expression: "form.summaryText"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Customer") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "298px" },
                    attrs: {
                      "callback-params": { key: "customer" },
                      "default-value": _vm.form.customer,
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "callback-method-type": "value",
                      filterable: "",
                      no: "7"
                    },
                    on: { parentCallBack: _vm.selectChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_AccountTitle") } },
                [
                  _c(
                    "el-select",
                    {
                      ref: "accountTitleRef",
                      staticStyle: { width: "298px" },
                      attrs: { filterable: true, clearable: true, no: "8" },
                      model: {
                        value: _vm.form.accountTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "accountTitle", $$v)
                        },
                        expression: "form.accountTitle"
                      }
                    },
                    _vm._l(_vm.currentAccountTitleCollection, function(
                      item,
                      index
                    ) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.accountTitleLabelFun(item),
                          value: item.uuid
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Currency") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { no: "9" },
                      model: {
                        value: _vm.form.currency,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "currency", $$v)
                        },
                        expression: "form.currency"
                      }
                    },
                    _vm._l(_vm.usedCurrencyCollection, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "el-form-item-search",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_WriteOff") }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "10" },
                      model: {
                        value: _vm.form.clear,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "clear", $$v)
                        },
                        expression: "form.clear"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: -1 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_All")))
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WrittenOff")))
                      ]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NotWrittenOff")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Sales") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "140px" },
                    attrs: {
                      "callback-params": { key: "sales" },
                      "default-value": _vm.form.sales,
                      "select-type": _vm.selectTypeNames.basic_data_User,
                      "callback-method-type": "value",
                      filterable: "",
                      no: "11"
                    },
                    on: { parentCallBack: _vm.selectChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "el-form-item-search",
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_RevenueOrExpenditure")
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "12" },
                      model: {
                        value: _vm.form.debitCrebit,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "debitCrebit", $$v)
                        },
                        expression: "form.debitCrebit"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: -1 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_All")))
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Receivable")))
                      ]),
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Dues")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-checkbox", {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_ShowAdjustRateEntry"),
                      no: "13"
                    },
                    model: {
                      value: _vm.form.showAdjustRateEntry,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showAdjustRateEntry", $$v)
                      },
                      expression: "form.showAdjustRateEntry"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "el-margin",
                      staticStyle: { "margin-left": "20px" },
                      attrs: { type: "primary", no: "14" },
                      on: { click: _vm.doSearch }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "15" },
                      on: { click: _vm.writeoffHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_WriteOffReverseWriteOff"))
                      )
                    ]
                  ),
                  _vm.updateAccountingEntryPaidOffFlag && _vm.isPlatformService
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "16" },
                          on: { click: _vm.updatePaidOffFlag }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_UpdatePaidOffFlag"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1", padding: "0px" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "800px" },
            attrs: {
              "show-side-bar": false,
              "column-defs": _vm.columnDefs,
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.girdParams,
              "row-data": _vm.rowData,
              "auto-fit-content": false,
              no: "16"
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _c("debit-credit-total-group", {
            staticStyle: { float: "right", "margin-right": "10px" },
            attrs: {
              "row-data": _vm.rowData,
              visible: _vm.totalGroupVisible,
              no: "17"
            },
            on: {
              clickCallBack: function($event) {
                _vm.totalGroupVisible = !_vm.totalGroupVisible
              }
            }
          })
        ],
        1
      ),
      _c("input-auxiliary-number-dialog", {
        attrs: {
          "entry-list": _vm.inputAuxiliaryNumberDialog.entryList,
          visible: _vm.inputAuxiliaryNumberDialog.visible,
          no: "18"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.inputAuxiliaryNumberDialog, "visible", $event)
          },
          close: function() {
            return (_vm.inputAuxiliaryNumberDialog.visible = false)
          },
          refresh: _vm.doSearch
        }
      }),
      _vm.accountingEntryWindow.visible
        ? _c("accounting-entry-window", {
            attrs: {
              "account-set": _vm.accountSet,
              "account-title-data-provider":
                _vm.accountingEntryWindow.accountTitleDataProvider,
              index: _vm.accountingEntryWindow.index,
              "is-ext": _vm.isExt,
              "mapping-departments": _vm.mappingDepartments,
              "mapping-staffs": _vm.mappingStaffs,
              "prefix-data-provider": _vm.prefixDataProvider,
              visible: _vm.accountingEntryWindow.visible,
              voucher: _vm.accountingEntryWindow.voucher,
              no: "19"
            },
            on: {
              close: function() {
                return (_vm.accountingEntryWindow.visible = false)
              },
              updateTargetDocumentNo: _vm.updateTargetDocumentNo
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }